import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationPopupComponent } from './notification-popup/notification-popup.component';
import { MaterialAppModule } from 'src/app/material.module';
import { NotificationItemComponent } from './notification-item/notification-item.component';
import { ViewAllNotificationItemComponent } from './view-all-notification-item/view-all-notification-item.component';
import { NotificationApiHandlerService } from './notification-api-handler.service';
import { NotificationService } from './notification.service';
import { NotificationSocketService } from './notification-socket.service';
import { NotificationAlertComponent } from './notification-alert/notification-alert.component';
import { NotificationAlertService } from './notification-alert.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    NotificationItemComponent,
    NotificationPopupComponent,
    NotificationAlertComponent,
    ViewAllNotificationItemComponent,
  ],
  imports: [CommonModule, MaterialAppModule, FormsModule],
  providers: [
    NotificationService,
    NotificationSocketService,
    NotificationApiHandlerService,
    NotificationAlertService,
  ],
  exports: [
    NotificationPopupComponent,
    NotificationItemComponent,
    ViewAllNotificationItemComponent,
  ],
})
export class NotificationModule {}
